import adminTheme from './adminTheme';

export default adminTheme;
